import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IAnnotationType } from 'gen/ApiClient';

export const AnnotationTypesCacheContext = React.createContext<IPreloadCacheContext<IAnnotationType[]>>(undefined as any);
